







































































import { PropType } from 'vue';
import { CommentModel } from '../../../shared/models/comment.model';
import Icon from '../../../shared/components/Icon.vue';
import { iconClassEnum } from '../../../shared/enums/iconClassEnum';
import * as dateUtil from '../../../shared/utils/dateUtil.js';
import { dateFormatEnum } from '../../../shared/enums/dateFormatEnum';
import capitalize from 'lodash/capitalize';
import { mapGetters, mapMutations } from 'vuex';
import { types } from '../../store/types/types.js';
import CommentTextarea from './CommentTextarea.vue';
import { commentService } from '../../../shared/services/api/comment.service';
import AulaButton from '../../../shared/components/AulaButton.vue';
import { DeleteCommentRequest } from '../../../shared/models/requests/deleteComment.request';
import { ReportCommentRequest } from '../../../shared/models/requests/reportComment.request';
import ContactAvatar from '../contacts/ContactAvatar.vue';

export default {
  components: { ContactAvatar, AulaButton, CommentTextarea, Icon },
  props: {
    comment: { type: Object as PropType<CommentModel>, required: true },
    showReportedContent: { type: Boolean, default: false },
    highlighted: { type: Boolean, default: false },
    isNew: { type: Boolean, default: false },
  },
  data() {
    return {
      isEditing: false,
      isDeleted: false,
      isReported: false,
      originalContent: '',
      content: '',
      reportReason: '',
      reportedContentWarning: null,
    };
  },
  computed: {
    ...mapGetters({
      institutions: types.GET_INSTITUTIONS,
    }),
    isReportReasonTooShort() {
      return this.reportReason.length >= 0 && this.reportReason.length < 10;
    },
    canViewProfile() {
      return !this.showReportedContent;
    },
    creator() {
      if (this.isDeleted || (this.isReported && !this.showReportedContent)) {
        return null;
      }
      return this.comment.creator;
    },
    iconClassEnum() {
      return iconClassEnum;
    },
    commentDateTime() {
      const commentDate = this.comment.updatedAt || this.comment.createdAt;
      const date = dateUtil.getRelativeDateTime(commentDate);
      let suffix = '';
      if (this.comment.updatedAt) {
        suffix = `(${this.$getText('EDITED')})`;
      }
      if (this.comment.isReported) {
        suffix = `(${this.$getText('REPORTED')})`;
      }
      return capitalize(`${date} ${suffix}`);
    },
    commentDateTimeTooltip() {
      const commentDate = this.comment.updatedAt || this.comment.createdAt;
      return capitalize(dateUtil.format(commentDate, dateFormatEnum.FULL_DATE));
    },
    canEdit() {
      return this.institutions.some(
        institution => institution.institutionProfileId === this.comment.creator?.id && !institution.communicationBlock
      );
    },
    canPerformActions() {
      return !this.isDeleted && !this.isReported && (this.comment.canDelete || this.comment.canReport);
    },
    canViewContent() {
      return !this.isDeleted && (!this.isReported || this.showReportedContent) && !this.isEditing;
    },
    isValidReport() {
      return this.reportedContentWarning == null;
    },
  },
  mounted() {
    this.originalContent = this.comment.content;
    this.isDeleted = this.comment.isDeleted;
    this.isReported = this.comment.isReported;
  },
  methods: {
    ...mapMutations({
      setSuccessText: types.MUTATE_SUCCESS_TEXT,
      setErrorText: types.MUTATE_ERROR_TEXT,
    }),
    cancelReporting() {
      this.$refs.reportContentModal.hide();
      this.reportedContentWarning = null;
      this.reportReason = '';
    },
    handleEditClicked() {
      this.isEditing = true;
      this.content = this.originalContent;
      this.$nextTick(() => {
        this.$refs.textarea.focus();
      });
    },
    handleDeleteClicked() {
      this.$refs.deletionModal.show();
    },
    handleReportClicked() {
      this.$refs.reportContentModal.show();
    },
    confirmDeletion() {
      this.$refs.deletionModal.hide();
      this.deleteComment();
      this.isDeleted = true;
    },
    confirmReporting() {
      if (this.isReportReasonTooShort) {
        this.reportedContentWarning = this.$t('warning.reported_content_too_short');
        return;
      }
      this.$refs.reportContentModal.hide();
      this.reportComment();
    },
    handleSubmitClicked() {
      this.updateComment();
      this.originalContent = this.content;
      this.isEditing = false;
    },
    async updateComment() {
      const params = {
        commentId: this.comment.id,
        content: this.content,
      };
      await commentService.updateComment(params);
      this.setSuccessText('COMMENTS_COMMENT_IS_UPDATED');
    },
    async deleteComment() {
      const payload: DeleteCommentRequest = {
        commentId: this.comment.id,
      };
      await commentService.deleteComment(payload);
      this.setSuccessText('COMMENTS_COMMENT_IS_DELETED');
    },
    async reportComment() {
      try {
        const payload: ReportCommentRequest = {
          commentId: this.comment.id,
          reportReason: this.reportReason,
        };
        await commentService.reportComment(payload);
        this.setSuccessText('COMMENTS_COMMENT_IS_REPORTED');
        this.isReported = true;
      } catch {
        this.setErrorText('API_ERROR_GENERAL');
      }
    },
    reset() {
      this.isEditing = false;
      this.content = this.originalContent;
    },
    handleReportedContentInput() {
      switch (true) {
        case this.isReportReasonTooShort:
          this.reportedContentWarning = this.$getText('REPORTED_CONTENT_REASON_LENGTH_WARNING_TOO_SHORT');
          break;
        case this.reportReason.length > 255:
          this.reportedContentWarning = this.$getText('REPORTED_CONTENT_REASON_LENGTH_WARNING_TOO_LONG');
          break;
        default:
          this.reportedContentWarning = null;
      }
    },
  },
};
